import Vue from 'vue';   

import Print from 'vue-print-nb'; //打印插件
Vue.use(Print);

import moment from 'moment';  
Vue.prototype.$moment=moment;

import WebOffice from '../components/oa/view/webOffice/index'
Vue.use(WebOffice); 

//流程轨迹组件
import OAWFTrackExtend from '../components/oa/view/official/cmps/track_extend/list/index.js'
Vue.use(OAWFTrackExtend); 
//轨迹抽屉
import OAWFTrackDrawer from '../components/oa/view/official/cmps/track_extend/drawer/index.js'
Vue.use(OAWFTrackDrawer);

//流程删除按钮
import OABtnDel from '../components/oa/view/official/cmps/btnDel/index.js'
Vue.use(OABtnDel);

//流程轨迹横向组件
import OAWFTrackHor from '../components/oa/view/official/cmps/track/track_hor/index.js'
Vue.use(OAWFTrackHor);


//流程轨迹竖向组件
import OAWFTrackVer from '../components/oa/view/official/cmps/track/track_ver/index.js'
Vue.use(OAWFTrackVer);


//公文详情组件 
import OADocInfo from '../components/oa/view/basics/docInfo/index.js'
Vue.use(OADocInfo);

//发文详情组件
import SendView from '../components/oa/view/official/sendDoc/view/view.vue'
Vue.component('send-view', SendView);
Vue.use(SendView);

//收文详情组件
import ReceiveView from '../components/oa/view/official/receive/view/view.vue'
Vue.component('receive-view', ReceiveView);
Vue.use(ReceiveView);

//意见稿详情组件
import OpinionView from '../components/oa/view/official/opinion/view/view.vue'
Vue.component('opinion-view', OpinionView);
Vue.use(OpinionView);

//签报详情组件
import SignView from '../components/oa/view/official/signDoc/view/view.vue'
Vue.component('sign-view', SignView);
Vue.use(SignView);

//报表详情组件
import RePortView from '../components/oa/view/official/rePort/view/view.vue'
Vue.component('rePort-view', RePortView);
Vue.use(RePortView);
//任务详情组件
import TaskView from '../components/oa/view/official/task/view/view.vue'
Vue.component('task-view', TaskView);
Vue.use(TaskView);
//休假详情组件
import LeaveView from '../components/oa/view/official/leave/view/view.vue'
Vue.component('leave-view', LeaveView);
Vue.use(LeaveView);
//出差详情组件
import BusinessView from '../components/oa/view/official/business/view/view.vue'
Vue.component('business-view', BusinessView);
Vue.use(BusinessView);
//加班详情组件
import OvertimeView from '../components/oa/view/official/overtime/view/view.vue'
Vue.component('overtime-view', OvertimeView);
Vue.use(OvertimeView);
//值班详情组件
import DutyView from '../components/oa/view/official/duty/view/view.vue'
Vue.component('duty-view', DutyView);
Vue.use(DutyView);
//信息详情组件
import InfoView from '../components/oa/view/official/info/view/view.vue'
Vue.component('info-view', InfoView);
Vue.use(InfoView);

//议题详情组件
import MotionView from '../components/oa/view/meeting/motion/view/view.vue'
Vue.component('motion-view', MotionView);
Vue.use(MotionView);

//议题报签详情组件
import MettingSignView from '../components/oa/view/meeting/sign/view/view.vue'
Vue.component('metting-sign-view', MettingSignView);
Vue.use(MettingSignView);

//会议纪要详情组件
import MinutesView from '../components/oa/view/meeting/minutes/view/view.vue'
Vue.component('minutes-view', MinutesView);
Vue.use(MinutesView);
//补休详情组件
import CompensatoryView from '../components/oa/view/official/compensatory/view/view.vue'
Vue.component('compensatory-view', CompensatoryView);
Vue.use(CompensatoryView);


//通知公告详情
import NoticeView from '../components/oa/view/basics/noticeInfo/view/view.vue'
Vue.component('notice-view', NoticeView);
Vue.use(NoticeView);


// WEBPACK FOOTER //
// ./src/config/biz.js